import { Fab } from "@mui/material";
import classes from './FloatingButton.module.scss';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import { useEffect, useState } from "react";

const FloatingButton = () => {
  const [showButton, setShowButton] = useState<boolean>(false);

  useEffect(() => {
    const handleScrollButtonVisibilty = () => {
      setShowButton(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScrollButtonVisibilty);

    return () => {
      window.removeEventListener('scroll', handleScrollButtonVisibilty);
    };
  }, []);
  const fabClickHandler = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <>
      {showButton && (
        <Fab className={classes.fab} onClick={fabClickHandler} size='small'>
          <ArrowDropUpIcon />
        </Fab>
      )}
    </>
  )
};

export default FloatingButton;
